import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MastercardLandingPageComponent } from "@app/core/ui-components/mastercard-landing-page";

const routes: Routes = [
  {
    path: "mastercard-landing-page",
    component: MastercardLandingPageComponent,
  },
  {
    path: "mastercard-landing-page/:hash",
    component: MastercardLandingPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
